import React, { useState } from "react";
import Card from "../cards/Card";
import AdminPagination from "../Pageination/AdminPagination";
import { BtnAlternative } from "../buttons/Btn";
import { Modal } from "../modal/Modal";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import TableSort from "./TableSort/TableSort";

function IdeasTable(props) {
    //const { items, requestSort, sortConfig } = TableSort(props.list);
    const [priority, setPriority] = useState(false);
    const [priorityid, setPriorityid] = useState([]);
    const [priorityid1, setPriorityid1] = useState(1);
    const handleClick = (id) => {
        setPriorityid1(id);

        if (id < 5) {
            setPriorityid((prev) => [...prev, id]);
        }
        if (priorityid.includes(id)) {
            setPriorityid(priorityid.filter((el) => el !== id));
        }
    };
    const handleremove = (id) => {
        setPriorityid(priorityid.filter((el) => el !== id));
        setPriorityid1(id);
    };

    return (
        <div className="mx-5 ">
            {props.priority && priorityid1 < 5 && (
                <p className=" text-[#B00020] font-normal text-[1.2rem] leading-[2.4rem] mb-[0.3rem] pr-[0.5rem]">
                    *شما هنوز اولویت{" "}
                    <span>
                        {!priorityid.includes(1)
                            ? "اول"
                            : !priorityid.includes(2)
                            ? "دوم"
                            : !priorityid.includes(3)
                            ? "سوم"
                            : !priorityid.includes(4) && "چهارم"}
                    </span>{" "}
                    خود را ثبت نکرده اید!
                </p>
            )}
            <Card className="IdeasPriorityTable-card SupportTicketTable-header ">
                {props.header.map((item, id) => (
                    <div
                        className={
                            props.sort &&
                            props.num === id &&
                            ` cursor-pointer flex flex-row items-center`
                        }
                        //onClick={() => props.num === id && requestSort("id")}
                    >
                        {item.title}
                        {/* {props.sort &&
                            props.num === id &&
                            (sortConfig?.direction === "ascending" ? (
                                <AiOutlineDown className=" mr-[0.3rem]" />
                            ) : (
                                <AiOutlineUp className=" mr-[0.3rem]" />
                            ))} */}
                    </div>
                ))}
            </Card>
            {props.list.map((i, id) => (
                <Card
                    key={i?.id}
                    className="IdeasPriorityTable-card SupportTicketTable-body my-4"
                >
                    <div>{i?.idea_name}</div>
                    {i?.is_confirmed ? (
                        <div style={{ color: "green" }}>تایید شده</div>
                    ) : (
                        <div style={{ color: "red" }}>تایید نشده</div>
                    )}
                    <div>{i?.priority}</div>

                    <div className="flex">
                        <p
                            className="px-10 py-6 self-center text-red-700 cursor-pointer"
                            onClick={() => props.setDeleteIdeaId(i.id)}
                        >
                            حذف اولویت
                        </p>
                        <BtnAlternative
                            text="مشاهده ایده"
                            className="px-10 py-6 self-center"
                            onClick={() => {
                                props.showModal();
                                props.setEditIdeaId(i.id);
                            }}
                        />
                    </div>
                </Card>
            ))}
            {props.children}
        </div>
    );
}

export default IdeasTable;
